import { useMemo } from "react";

import { CaseServiceV2 } from "../services/caseServiceV2";
import { useAPI } from "./useAPI";

export const useCaseService = () => {
  const api = useAPI("v2");
  return useMemo(() => new CaseServiceV2(api), [api]);
};
